/* unplugin-vue-components disabled */import __unplugin_components_0 from '/Users/Zhuanz/Desktop/project/oral-app/src/components/Tabbar.vue';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "cross-container"
};
import { factoryApi, projectTypeApi, addApi } from "@/api/shipment";
import { uploadApi } from "@/api/upload";
import router from "@/router";
import { showNotify } from "vant";
export default /*@__PURE__*/_defineComponent({
  __name: 'Add',
  setup(__props) {
    const showPicker = ref(false);
    const fileParam = ref({
      base64: "",
      url: ""
    });
    const factoryData = ref([]);
    const projectTypeData = ref([]);
    onMounted(async () => {
      const res = await factoryApi();
      if (res.code == 200) {
        factoryData.value = res.data ?? [];
      } else {
        showNotify({
          type: "danger",
          message: res.msg
        });
      }
      const result = await projectTypeApi();
      if (result.code == 200) {
        projectTypeData.value = result.data ?? [];
      } else {
        showNotify({
          type: "danger",
          message: result.msg
        });
      }
    });
    const loading = ref(false);
    const param = ref({
      name: "",
      factoryId: "",
      projectInfoId: "",
      outboundTime: "",
      rightTop: "",
      rightBottom: "",
      leftTop: "",
      leftBottom: "",
      phone: "",
      image: "",
      rework: 0,
      sex: 0
    });
    const projectName = ref("");
    const fieldNames = ref({
      text: "name",
      value: "id",
      children: "children"
    });
    const showPicker2 = ref(false);
    const onConfirm2 = ({
      selectedOptions
    }) => {
      console.log(selectedOptions);
      showPicker2.value = false;
      projectName.value = selectedOptions[1].name;
      param.value.projectInfoId = selectedOptions[1].id;
    };
    const customFieldName = ref({
      text: "name",
      value: "id"
    });
    const factortyName = ref("");
    const showPicker1 = ref(false);
    const onConfirm = ({
      selectedOptions
    }) => {
      showPicker.value = false;
      param.value.outboundTime = selectedOptions[0].value + "-" + selectedOptions[1].value + "-" + selectedOptions[2].value;
    };
    const onConfirm1 = ({
      selectedOptions
    }) => {
      showPicker1.value = false;
      factortyName.value = selectedOptions[0].name;
      param.value.factoryId = selectedOptions[0].id;
    };
    const currentDate = ref(new Date());
    const onClickLeft = () => history.back();
    const submit = async () => {
      loading.value = true;
      const res = await addApi(param.value);
      loading.value = false;
      if (res.code == 200) {
        showNotify({
          type: "success",
          message: res.msg
        });
        router.push({
          path: "/"
        });
      } else {
        showNotify({
          type: "danger",
          message: res.msg
        });
      }
    };
    const fileList = ref([]);
    const beforeRead = file => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file); // 文件上传
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          if (!ctx) {
            throw new Error("无法获取2D渲染上下文");
          }
          canvas.width = img.width;
          const scale = 1024 / img.height;
          canvas.height = img.height * scale;
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          canvas.toBlob(blob => {
            const resFile = new File([blob], file.name, {
              type: file.type
            });
            resolve(resFile);
          });
        };
      });
    };
    const afterRead = async (file, detail) => {
      file.status = "uploading";
      file.message = "上传中...";
      const res = await uploadApi(file.file);
      console.log(res, "上传图片----------");
      if (res.code == 200) {
        file.status = "done";
        param.value.image = res.data ?? "";
      } else {
        file.status = "failed";
        showNotify({
          type: "danger",
          message: "上传失败"
        });
      }
    };
    const beforeDelete = (file, detail) => {
      fileList.value.splice(detail.index, 1);
      param.value.image = "";
    };
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      const _component_van_radio = _resolveComponent("van-radio");
      const _component_van_radio_group = _resolveComponent("van-radio-group");
      const _component_van_cell = _resolveComponent("van-cell");
      const _component_van_cascader = _resolveComponent("van-cascader");
      const _component_van_date_picker = _resolveComponent("van-date-picker");
      const _component_van_col = _resolveComponent("van-col");
      const _component_van_row = _resolveComponent("van-row");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_uploader = _resolveComponent("van-uploader");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_form = _resolveComponent("van-form");
      const _component_tabbar = __unplugin_components_0;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createVNode(_component_van_nav_bar, {
        title: "添加出库",
        "left-arrow": "",
        onClickLeft: onClickLeft
      }), _createVNode(_component_van_form, {
        class: "form",
        onSubmit: submit
      }, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: _unref(factortyName),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(factortyName) ? factortyName.value = $event : null),
          label: "加工厂",
          placeholder: "请选择加工厂",
          clearable: "",
          "is-link": "",
          readonly: "",
          onClick: _cache[1] || (_cache[1] = $event => showPicker1.value = true)
        }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
          show: _unref(showPicker1),
          "onUpdate:show": _cache[3] || (_cache[3] = $event => _isRef(showPicker1) ? showPicker1.value = $event : null),
          "destroy-on-close": "",
          round: "",
          position: "bottom"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_picker, {
            columns: _unref(factoryData),
            "columns-field-names": _unref(customFieldName),
            onCancel: _cache[2] || (_cache[2] = $event => showPicker1.value = false),
            onConfirm: onConfirm1
          }, null, 8, ["columns", "columns-field-names"])]),
          _: 1
        }, 8, ["show"]), _createVNode(_component_van_field, {
          modelValue: _unref(param).name,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(param).name = $event),
          label: "患者姓名",
          placeholder: "请输入患者姓名",
          required: "",
          clearable: "",
          rules: [{
            required: true,
            message: '请输入患者姓名',
            trigger: 'onBlur'
          }]
        }, null, 8, ["modelValue"]), _createVNode(_component_van_cell, {
          title: "患者性别",
          class: "rework"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_radio_group, {
            modelValue: _unref(param).sex,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(param).sex = $event),
            direction: "horizontal"
          }, {
            default: _withCtx(() => [_createVNode(_component_van_radio, {
              name: 0
            }, {
              default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("男")])),
              _: 1,
              __: [22]
            }), _createVNode(_component_van_radio, {
              name: 1
            }, {
              default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("女")])),
              _: 1,
              __: [23]
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_van_cell, {
          title: "是否返工",
          class: "rework"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_radio_group, {
            modelValue: _unref(param).rework,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(param).rework = $event),
            direction: "horizontal"
          }, {
            default: _withCtx(() => [_createVNode(_component_van_radio, {
              name: 0
            }, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [_createTextVNode("否")])),
              _: 1,
              __: [24]
            }), _createVNode(_component_van_radio, {
              name: 1
            }, {
              default: _withCtx(() => _cache[25] || (_cache[25] = [_createTextVNode("是")])),
              _: 1,
              __: [25]
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_van_field, {
          modelValue: _unref(param).phone,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(param).phone = $event),
          type: "tel",
          label: "手机号码",
          placeholder: "请输入手机号码",
          clearable: ""
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: _unref(projectName),
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _isRef(projectName) ? projectName.value = $event : null),
          label: "项目名称",
          placeholder: "请选择项目名称",
          clearable: "",
          show: _unref(showPicker2),
          "onUpdate:show": _cache[9] || (_cache[9] = $event => _isRef(showPicker2) ? showPicker2.value = $event : null),
          onClick: _cache[10] || (_cache[10] = $event => showPicker2.value = true),
          "is-link": "",
          readonly: ""
        }, null, 8, ["modelValue", "show"]), _createVNode(_component_van_popup, {
          show: _unref(showPicker2),
          "onUpdate:show": _cache[12] || (_cache[12] = $event => _isRef(showPicker2) ? showPicker2.value = $event : null),
          "destroy-on-close": "",
          round: "",
          position: "bottom"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_cascader, {
            onFinish: onConfirm2,
            onClose: _cache[11] || (_cache[11] = $event => showPicker2.value = false),
            options: _unref(projectTypeData),
            "field-names": _unref(fieldNames)
          }, null, 8, ["options", "field-names"])]),
          _: 1
        }, 8, ["show"]), _createVNode(_component_van_field, {
          modelValue: _unref(param).outboundTime,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(param).outboundTime = $event),
          label: "出库日期",
          placeholder: "请选择出库日期",
          clearable: "",
          onClick: _cache[14] || (_cache[14] = $event => showPicker.value = true),
          "is-link": "",
          required: "",
          rules: [{
            required: true,
            message: '请选择出库日期',
            trigger: 'onBlur'
          }],
          readonly: ""
        }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
          show: _unref(showPicker),
          "onUpdate:show": _cache[16] || (_cache[16] = $event => _isRef(showPicker) ? showPicker.value = $event : null),
          "destroy-on-close": "",
          round: "",
          position: "bottom"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_date_picker, {
            onCancel: _cache[15] || (_cache[15] = $event => showPicker.value = false),
            onConfirm: onConfirm,
            type: "date",
            "min-date": _unref(currentDate)
          }, null, 8, ["min-date"])]),
          _: 1
        }, 8, ["show"]), _createVNode(_component_van_cell_group, {
          title: "牙位信息"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_cell, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_row, null, {
              default: _withCtx(() => [_createVNode(_component_van_col, {
                span: "12"
              }, {
                default: _withCtx(() => [_createVNode(_component_van_field, {
                  modelValue: _unref(param).rightTop,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _unref(param).rightTop = $event),
                  type: "number",
                  class: "text-align-right",
                  placeholder: " 87654321",
                  required: "",
                  clearable: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_van_col, {
                span: "12"
              }, {
                default: _withCtx(() => [_createVNode(_component_van_field, {
                  modelValue: _unref(param).leftTop,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => _unref(param).leftTop = $event),
                  type: "number",
                  placeholder: "12345678",
                  required: "",
                  clearable: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_van_row, null, {
              default: _withCtx(() => [_createVNode(_component_van_col, {
                span: "12"
              }, {
                default: _withCtx(() => [_createVNode(_component_van_field, {
                  modelValue: _unref(param).rightBottom,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => _unref(param).rightBottom = $event),
                  type: "number",
                  class: "text-align-right",
                  placeholder: "87654321",
                  required: "",
                  clearable: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_van_col, {
                span: "12"
              }, {
                default: _withCtx(() => [_createVNode(_component_van_field, {
                  modelValue: _unref(param).leftBottom,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => _unref(param).leftBottom = $event),
                  type: "number",
                  placeholder: "12345678",
                  required: "",
                  clearable: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_van_cell, {
          title: "附件"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_uploader, {
            modelValue: _unref(fileList),
            "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => _isRef(fileList) ? fileList.value = $event : null),
            "max-count": 1,
            "after-read": afterRead,
            "before-delete": beforeDelete
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_van_cell_group, null, {
          default: _withCtx(() => [_createVNode(_component_van_button, {
            class: "btn",
            type: "primary",
            loading: _unref(loading),
            "native-type": "submit"
          }, {
            default: _withCtx(() => _cache[26] || (_cache[26] = [_createTextVNode("保存")])),
            _: 1,
            __: [26]
          }, 8, ["loading"])]),
          _: 1
        })]),
        _: 1
      })]), _createVNode(_component_tabbar)], 64);
    };
  }
});